@let isGroup = chat()?.conversation_type === ConversationType.group;
@let isUnread = !!chat()?.unread_messages_ids?.length;

<div
  class="chat"
  [class.active]="isActive()"
  [class.unread]="isUnread"
  (click)="chatSelected.emit(chat())">
  <app-user-avatar
    radius="12px"
    [size]="48"
    [fontSize]="18"
    [avatar]="chat()?.image"
    [name]="chat()?.name"
    [avatars]="avatars()">
  </app-user-avatar>

  <div class="chat__info">
    <div class="name-type-time">
      <div class="name-and-type">
        <span class="name ellipsis" [class.is-group]="isGroup">{{ chat()?.name }}</span>
        @if (isGroup) {
          <mat-icon
            class="material-icons-outlined"
            [matTooltip]="'messageCenter.conversationType_group' | translate">
            group
          </mat-icon>
        }
      </div>

      @if (!!lastMessageTime()) {
        <span class="last-message-time">{{ lastMessageTime() }}</span>
      }
    </div>

    @if (chat()?.last_message?.text || chat()?.last_message?.has_files) {
      <div class="last-message">
        @let type = lastMessageType[chat()?.last_message?.channel];
        <mat-icon class="material-icons-outlined" [ngClass]="type?.class">
          {{ type?.icon }}
        </mat-icon>

        <span class="message ellipsis">
          @if (isGroup || isMine()) {
            {{ isMine() ? ('messageCenter.you' | translate) : chat()?.last_message?.sender?.short_name }}:
          }

          @if (chat()?.last_message?.text) {
            {{ chat()?.last_message?.text }}
          } @else if (chat()?.last_message?.has_files) {
            <mat-icon class="material-icons-outlined">image</mat-icon>
            {{ 'messageCenter.attachment' | translate }}
          }
        </span>

        @if (isUnread) {
          <div class="unread-count">{{ chat()?.unread_messages_ids?.length }}</div>
        }
      </div>
    }
  </div>

  @if (chat()?.id) {
    <mat-icon
      class="material-icons-outlined icon-delete"
      [matTooltip]="'messageCenter.deleteChat' | translate"
      (click)="$event.stopPropagation(); deleteChat.emit()">
      delete
    </mat-icon>
  }
</div>
